export default __webpack_public_path__ + "static/media/mvsi-web-logo.3c05a84e.png";